import { type GlobalThemeOverrides, lightTheme } from "naive-ui";
import { defineStore } from "pinia";
import { theme as themeConst } from "./../constants/theme";

export const useThemeStore = defineStore("theme", () => {
  const theme = lightTheme;
  const themeOverrides: GlobalThemeOverrides = {
    common: {
      fontFamily: "'Figtree', 'sans-serif",
      primaryColor: themeConst.colors.primary["500"],
      primaryColorHover: themeConst.colors.primary["600"],
      primaryColorPressed: themeConst.colors.primary["600"],
      primaryColorSuppl: themeConst.colors.primary["600"],
      borderRadius: "0.375rem",
    },
  };

  return {
    theme,
    themeOverrides,
  };
});
